<ng-container *transloco="let t">
  <div class="grey-neutral-50-bg live-results" [ngClass]="{ 'pb-300-228': isFullScreen }">
    @if (race && isFullScreen) {
      <ng-template [ngTemplateOutlet]="fullScreenHeader"></ng-template>
      @if (fullScreenMode === FullScreenMode.FULL) {
        <ng-template [ngTemplateOutlet]="results"></ng-template>
      } @else {
        <ng-template [ngTemplateOutlet]="splitResults"></ng-template>
      }
    } @else {
      <app-page-template [showBreadcrumbs]="false">
        <app-carousel [images]="[image]" [showGradient]="true"></app-carousel>
        <ng-template [ngTemplateOutlet]="header"></ng-template>
        <ng-template [ngTemplateOutlet]="results"></ng-template>
      </app-page-template>
    }

    <ng-template #fullScreenHeader>
      <div class="full-screen-header mb-4">
        <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages" [event]="event"
                                  [finished]="finishedCount ?? 0" [started]="startedCount ?? 0"
                                  [type]="LiveResultHeadingType.RACE" [hideStatusBadge]="true" cssClass="full-screen">
          <div class="d-flex align-items-end d-none d-xxl-flex">
            <h2 class="d-inline-flex text-uppercase">
              {{t("page.header.live.results")}} </h2>
          </div>
          <ng-container slot="title-slot">
            <div class="d-flex align-items-end d-flex d-xxl-none">
              <h2 class="d-inline-flex text-uppercase">
                {{t("page.header.live.results")}} </h2>
            </div>
          </ng-container>
        </app-live-results-heading>
      </div>
    </ng-template>


    <ng-template #resultsTable>
      <div class="live-results-card" [class.pb-40-48]="!isFullScreen">
        <app-live-results-table-body [competitorLiveResults]="competitorLiveResults" [measurementType]="measurementType"
                                     [raceSettings]="race?.raceSettings" [gender]="gender" [category]="category"
                                     [isRoundRace]="isRoundRace"/>
      </div>
      <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
    </ng-template>

    <ng-template #header>
      <div class="container pt-62-32">
        <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages"
                                  [finished]="finishedCount ?? 0" [started]="startedCount ?? 0" [event]="event"
                                  [type]="LiveResultHeadingType.RACE"/>
        <div class="live-results-filter">
          <div class="live-results-filter__items d-flex flex-nowrap align-items-center">
            <div class="live-results-filter__search-wrapper">
              <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                          (searchQuery)="handleInput($event)" [inputValue]="name"/>
            </div>
            <form #f class="d-flex align-items-center">
              <div class="contestants-filter__grid d-flex align-items-center">
                <div class="contestants-filter__grid-inner d-flex align-items-center">
                  <div ngbDropdown class="dropdown-small" container="body">
                    <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                      {{
                        gender
                          ? t("app.common.gender." + gender) : t("competitor.table.gender")
                      }}
                    </div>
                    <div ngbDropdownMenu aria-labelledby="genderDropdown">
                      <button ngbDropdownItem (click)="handleGenderSelection()">
                        {{t("app.common.all")}}
                        @if ((gender === undefined)) {
                          <i class="bi bi-check"></i>
                        }
                      </button>
                      @for (item of genders;track item.id) {
                        <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                          {{t("app.common.gender." + item.id)}}
                          @if (item.id === gender) {
                            <i class="bi bi-check"></i>
                          }
                        </button>
                      }
                    </div>
                  </div>
                  <div class="pe-3">
                    @if (filterCategories?.length ?? 0 > 0) {
                      <div ngbDropdown class="dropdown-small" container="body">
                        <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                          {{
                            category ? (filterCategories | getByField:"id":category:"code") : t(
                              "competitor.table.category")
                          }}
                        </div>
                        <div ngbDropdownMenu aria-labelledby="categoryDropdown">
                          <button ngbDropdownItem (click)="handleCategorySelection()">
                            {{t("app.common.all")}}
                            @if ((category === undefined)) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                          @for (item of filterCategories;track item) {
                            <button ngbDropdownItem (click)="handleCategorySelection(item.id)">
                              {{item.code}}
                              @if (item.id == category) {
                                <i class="bi bi-check"></i>
                              }
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #fullScreenFooter>
      <app-full-screen-footer/>
    </ng-template>

    <ng-template #actionButtons>
      <div class="d-flex align-items-center justify-content-end py-3">
        <app-button-alt [borderColor]="'var(--teal-500)'" [textColor]="'var(--grey-neutral-800)'"
                        [buttonColor]="'transparent'" [text]="t(  'app.common.back')"
                        (onClickCallback)="back()"></app-button-alt>
        @if (isFullScreen) {
          <div class="px-2">
            <app-button-alt [buttonColor]="'var(--teal-500)'" [borderColor]="'var(--teal-500)'" [textColor]="'white'"
                            [text]="t(fullScreenMode === FullScreenMode.SPLIT ? 'live.results.see.all.full' : 'live.results.see.split')"
                            (onClickCallback)="toggleView()"></app-button-alt>
          </div>
        }
      </div>
    </ng-template>

    <ng-template #splitResults>
      <div class="px-3">
        <div class="row">
          <div class="col-md-6 col-12 pe-0 pe-md-2">
            <div class="table-header">
              <app-header-alt [title]=" t('app.common.gender.1') | uppercase"/>
            </div>
            <div class="live-results-card">
              <app-live-results-table-body [competitorLiveResults]="liveResultMale ?? []" [gender]="1"
                                           [raceSettings]="race?.raceSettings" [isRoundRace]="isRoundRace"
                                           [measurementType]="measurementType"/>
            </div>
          </div>
          <div class="col-md-6 col-12 ps-0 ps-md-2 pt-2 pt-md-0">
            <div class="table-header">
              <app-header-alt [title]=" t('app.common.gender.2') | uppercase"/>
            </div>
            <div class="live-results-card">
              <app-live-results-table-body [competitorLiveResults]="liveResultFemale ?? []" [gender]="2"
                                           [raceSettings]="race?.raceSettings" [isRoundRace]="isRoundRace"
                                           [measurementType]="measurementType"/>
            </div>
          </div>
        </div>
      </div>
      <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
    </ng-template>

    <ng-template #results>
      <div [class.padding-bottom-92]="!isFullScreen" [class.container]="!isFullScreen"
           [class.full-screen-container]="isFullScreen" [class.pb-300-228]="!isFullScreen"
           [class.mt-21]="!isFullScreen">
        <ng-template [ngTemplateOutlet]="resultsTable"></ng-template>
      </div>
    </ng-template>
  </div>

  @if (race && isFullScreen) {
    <ng-template [ngTemplateOutlet]="fullScreenFooter"></ng-template>
  }
</ng-container>
